import {siteListStore} from '../../features/site-list/store/site-list.store.ts';
import {articleListStore} from '../../features/article-list/store/article-list.store.ts';
import {articleSearchTableStore} from '../../features/article-search-table/store/article-search-table.store.ts';
import {siteSearchTableStore} from '../../features/site-search-table/store/site-search-table.store.ts';
import {CreateFormStore} from '../../shared/store/create-form.store.ts';

import {publishFormStore} from '../../features/publish-form/store/publish-form.store.ts';
import {CreateSiteType} from '@wp-content-publisher/typings-lib/dist/src/server/types/site.ts';
import {CreateArticleType} from '@wp-content-publisher/typings-lib/dist/src/server/types/article.ts';
import {loginPageStore} from '../../pages/login/store/login-page.store.ts';
import {MainPageStore} from '../../pages/main/store/main-page.store.ts';
import {ArticleType, SiteType} from '@wp-content-publisher/typings-lib';

class RootStore {
    loginPage = loginPageStore;
    siteForm = new CreateFormStore({
        domain: '',
        password: '',
        name: '',
        description: '',
    } as CreateSiteType);
    articleForm = new CreateFormStore({
        html: '',
        name: '',
    } as CreateArticleType);
    siteList = siteListStore;
    articleList = articleListStore;
    articleSearch = articleSearchTableStore;
    siteSearch = siteSearchTableStore;
    publishForm = publishFormStore;
    mainPageSite = new MainPageStore<SiteType>();
    mainPageArticle = new MainPageStore<ArticleType>();
}

export default RootStore;